import { URL } from "../../utils/UrlConstants";
import { privateFetch } from "../../utils/CustomFetch.js";
import { properties } from "../../utils/Properties_es";
import { CONSTANT } from "../../utils/Constants";
import { ApartmentPendingResponse } from "./ApartmentPendingInterfaces";
import { UrlBase } from "../../url/Urls";

export const getRequest = async (page: any, companyId: number, apartment: string, state: string) : Promise<ApartmentPendingResponse> => {
  try {
    const response = await privateFetch.get(URL.REQUEST_APARTMENT_PENDING(page,UrlBase.registration_x_page,companyId,apartment,state));
    return response.data;
  } catch (error: any) {
    throw new Error(error);
  }
};


export const createRequest = async (data:any) => {
  let responseData = {};
  
  const requestBody = {
    id:data.id,
    amount: data.amount,
    apartment: null,
    company: data.company,
    expirationDate: data.expirationDate,
    registrationDate: data.registrationDate,
    state: data.state,
    title: data.title,
    currency: data.currency,
    userCreated: data.userCreated,
    userModified: null
  };

  
  await privateFetch
    
    .post(URL.REQUEST_APARTMENT_PENDING_CREATE(data.apartment.id), requestBody, {
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
   
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_save_error);
    });
  return responseData;
};

export const updateRequest = async (data:any) => {
  let responseData = {};  
  const requestBody = {
    amount: data.amount,
    apartment: null ,
    company: data.company,
    expirationDate: data.expirationDate,
    registrationDate: data.registrationDate,
    state: data.state,
    title: data.title,
    currency: data.currency,
    userCreated: data.userModified,
    userModified: data.userModified
  };
  
  await privateFetch
    .put(URL.REQUEST_APARTMENT_PENDING_UPDATE(data.id,data.apartment.id), requestBody,{
      headers: {
        ...CONSTANT.HEADER_TYPE,
      },
    })
    
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(properties.com_parval_label_role_update_error);
    });
  return responseData;
};


export const deleteRequest = async (id:any) => {
  let responseData = {};
  await privateFetch
    .delete(URL.REQUEST_APARTMENT_PENDING_DELETE(id), {})
    .then(async (response) => {
      responseData = await response.data;
    })
    .catch(async (error) => {
      throw new Error(
        properties.com_parval_label_booking_delete_error
      );
    });
  return responseData;
};